module.exports = __webpack_public_path__ + "static/media/IMG_1774-minJPG.ce75708b.jpg";